<template>
  <v-container class="mt-12 pt-8" style="background:#efefef;">
    <v-row style="background:#efefef;">
      <v-col cols="12" class="pa-0">
        <v-row class="py-1 px-5">
          <v-col cols="12" md="12">
            <v-row>
              <v-col cols="12" class="px-5" PANNELS>
                <v-card NotificationPanel :loading="loading">
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="12" md="12">
                            <Search 
                              :loading="loading"
                              :time="resource.time"
                              :count="resource.all"
                              :resourceSettings="resourceSettings" 
                              @searchResource="searchResource" 
                              @create="createSelector()"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
                            <Paging 
                              :resourceSettings="resourceSettings" 
                              :resource="resource"
                              @loadResource="loadResource"
                              @pageByNumber="pageByNumber"
                            />
                          </v-col>
                          
                          <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`">
                            <ListActions
                              v-if="viewSelector('/actions')"
                              :resource="resource"
                              :resourceSettings="resourceSettings"
                              @editItem="edit"
                              @copyS="clipboardSuccessHandler"
                              @copyF="clipboardErrorHandler"
                              :loading="loading"
                              :resourceKeys="resourceKeys"
                            />
                            <ListPlatforms
                              v-if="viewSelector('/platforms')"
                              :resource="resource"
                              :resourceSettings="resourceSettings"
                              @editItem="edit"
                              @copyS="clipboardSuccessHandler"
                              @copyF="clipboardErrorHandler"
                              :loading="loading"
                              :resourceKeys="resourceKeys"
                            />
                            <ListEvents
                              v-if="viewSelector('/events')"
                              :resource="resource"
                              :resourceSettings="resourceSettings"
                              @editItem="edit"
                              @copyS="clipboardSuccessHandler"
                              @copyF="clipboardErrorHandler"
                              :loading="loading"
                              :resourceKeys="resourceKeys"
                            />

                            <ListDomains
                              v-if="viewSelector('/tracker-domains')"
                              :resource="resource"
                              :resourceSettings="resourceSettings"
                              @editItem="edit"
                              @copyS="clipboardSuccessHandler"
                              @copyF="clipboardErrorHandler"
                              :loading="loading"
                              :resourceKeys="resourceKeys"
                            />

                            <ListPixels
                              v-if="viewSelector('/tracker-pixels')"
                              :resource="resource"
                              :resourceSettings="resourceSettings"
                              @editItem="edit"
                              @copyS="clipboardSuccessHandler"
                              @copyF="clipboardErrorHandler"
                              :loading="loading"
                              :resourceKeys="resourceKeys"
                            />

                            <ListTrackers
                              v-if="viewSelector('/trackers')"
                              :resource="resource"
                              :resourceSettings="resourceSettings"
                              @editItem="edit"
                              @copyS="clipboardSuccessHandler"
                              @copyF="clipboardErrorHandler"
                              :loading="loading"
                              :resourceKeys="resourceKeys"
                            />
                            
                          </v-col>
                          <v-col cols="12" :class="`${arabic?'arFont':'enFont'}`" v-if="resource.data && resource.data.length > 8">
                            <Paging 
                              :resourceSettings="resourceSettings" 
                              :resource="resource"
                              @loadResource="loadResource"
                              @pageByNumber="pageByNumber"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <multiDialog
      :dialog="dialog"
      :loading="loading"
      :resourceSettings="resourceSettings"
      :deleting="deleting"
      :resourceKeys="resourceKeys"
      :newResource="newResource"
      @closeDialog="()=>{dialog = false;newResource={};}"
      @deleteResource="deleteResource"
      @updateResource="updateResource"
      @postResource="postResource"
      @getUpload="getUpload"
    />
  </v-container>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'
import ListActions from '@/components/ListActions'
import ListPlatforms from '@/components/ListPlatforms'
import ListEvents from '@/components/ListEvents'
import ListDomains from '@/components/ListDomains'
import ListPixels from '@/components/ListPixels'
import ListTrackers from '@/components/ListTrackers'
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};
const fireapi = 'https://us-central1-innovation-evotik.cloudfunctions.net/main';

export default {
  components: { Paging, Search, multiDialog, ListActions, ListEvents, ListPlatforms, ListDomains, ListPixels, ListTrackers },
  data() {
    return {
      loading:false,
      dialog:false,
      pdfreport:null,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[],
      resourceSettings:{},
      newResource:{},
      editing:false,
      deleting:false,
      newDialog:false,
      newUser:{},
      accounts:[],
      search_term:null,
    }
  },
  methods: {
    viewSelector(d) {
      if (this.resourceSettings.path == d && !this.loading) {
        return true
      } else {
        return false
      }
    },
    createSelector() {
      this.dialog = true
    },
    edit(r){
      this.dialog = true
      this.editing = true
      this.newResource = r
    },
    getUpload(o){
      this.newResource[o.field] = o.value
    },
    getFormat(d){
      return format(d)
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    clipboardSuccessHandler (){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler () {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async pageByNumber(n){
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.resourceSettings.path, page:`?page=${n}` + this.buildFilter()})
          this.accounts = this.resource.accounts
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.resourceSettings.path + `/search?page=${n}`, value:this.search})
        }
        this.loading = false
      })
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    searchResource(search){
      this.search_term = search
      this.filterResource()
    },
    buildFilter(){
      let filter = ``
      if(this.selectedAccount) {
        filter += `&filter[account_id]=${this.selectedAccount.id}`
      }
      if(this.search_term) {
        filter += `&filter[search]=${this.search_term}`
      }
      return filter
    },
    async filterResource(){
      await this.loadResource()
    },
    firstLoad(){
      if(this.user) {
      }
    },
    async loadResource() {
      return new Promise(async (res, rej)=>{
        this.loading = true
        if(!this.search){
          this.resource = await this.$store.dispatch('getResource', {resource:this.resourceSettings.path + '?' + this.buildFilter()})
        } else {
          this.resource = await this.$store.dispatch('searchResource', {resource:this.resourceSettings.path + '/search', value:this.search})
        }
        this.loading = false
        res()
      })
    },
    async updateResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        r.account_id = this.selectedAccount.id
        await this.$store.dispatch('putResource', {resource:this.resourceSettings.path + `/${r.id}`, value:r})
        this.dialog = false
        this.editing = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
      })
    },
    async deleteResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        r.account_id = this.selectedAccount.id
        await this.$store.dispatch('deleteResource', {resource:this.resourceSettings.path + `/${r.id}`})
        this.dialog = false
        this.deleting = false
        this.loading = false
        this.newResource = {}
        await this.loadResource()
      })
    },
    async postResource(r){
      return new Promise(async (res, rej)=>{
        this.loading = true
        r.account_id = this.selectedAccount.id
        await this.$store.dispatch('postResource', {resource:this.resourceSettings.path + `${r.id ? '/' + r.id : ''}`, value:r})
        this.dialog = false
        this.loading = false
        this.newResource = {}
        await this.loadResource()
      })
    },
    showPannel(v){
      this[v] = true
      let all = this.subitems.map(x=>x.value)
      all.filter(x=>x!=v).forEach(x=>this[x] = false)
    },
    async setResourceSettings() {
      return new Promise(async (res, rej) => {
        this.resourceSettings = this.$store.state.resourceSettings[this.base]
        this.resourceKeys = this.$store.state.resourceKeys[this.base]
        this.resourceSettings.path = this.path
        this.resourceSettings.resourceName = this.base
        res(true)
      })
    },
    async loadItems(base) {
      return new Promise(async (res, rej) => {
        let ks = this.$store.state.resourceKeys[base].filter(x => x.type == 'select' && x.source == 'db');
        (async x => {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            let t = this.resource[f.items]
            console.log(this.resource)
            console.log(f.items)
            console.log(t)
            let maps = t.map(x => {
              let t = x.name ? x.name : null
              return { ...x, text: t, [`${f.name}`]: x.id }
            })
            f.data = maps
          }
          res(true)
        })()
      })
    },
    async init(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        await this.setResourceSettings()
        await this.loadResource()
        await this.loadItems(this.base)
        this.loading = false
        res(true)
      })
    }
  },
  watch:{
    async $route(){
      await this.init()
    }
  },
  computed:{
    path() {
      return this.$route.path
    },
    base() {
      let base = this.path.replace('/', '')
      return base
    },
    sumRemainingSeats() {
      return this.$store.state.selectedAccount.plans.reduce((a, b) => a + b.users, 0) - this.resource.total
    },
    selectedAccount(){
      return this.$store.state.selectedAccount
    },
    checkDisabled(){
      if(this.user.role == 'master') {
        return false
      } else {
        return this.sumRemainingSeats > 0 ? false : true
      }
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.resourceSettings.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.resourceSettings.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    await this.init()
  },
}
</script>

<style>

</style>